<template>
<div>
    <datepicker
        :format="dateFormat"
        v-model="date"
        language="sv"
        input-class="form-control"
        @selected="updateDate"
        :monday-first="true"
        :clear-button="true">
    </datepicker>
</div>
</template>


<script>
    export default {

        props: {
            type: {},
            currentData: {}
        },

        data()
        {
            return {
                dateFormat: 'yyyy-MM-dd',
                date: (this.currentData.value ? moment(this.currentData.value).toDate() : null)
            }
        },

        methods: {

            updateDate(date)
            {
                let formatedDate = null
                if (date) {
                    formatedDate = moment(date).format('YYYY-MM-DD')
                }

                bus.$emit('date-changed', this.type, formatedDate)
            },

        },

        watch: {

            currentData() {

                this.date = (this.currentData.value ? moment(this.currentData.value).toDate() : null)
            }

        }

    }
</script>
